module.exports = __webpack_public_path__ + "img/ai.41316e87.png";